import Seo from "@/components/feature/Seo";
import LegalBody, { type LegalSection } from "@/pages/legal/components/LegalBody";

const sections: LegalSection[] = [
  {
    heading: "1. Acceptance of Terms",
    paragraphs: [
      "By using this website, you agree to these terms. If you do not agree, please do not use the website or submit an enquiry.",
    ],
  },
  {
    heading: "2. Nature of the Collaboration",
    paragraphs: [
      "KAL LORDS ZERO21 DJT is presented on this website as an EV retrofit technology collaboration between technology partners. Nothing on this website should be read as a claim of a merged entity, joint venture, subsidiary or a single combined manufacturing facility unless expressly stated.",
    ],
  },
  {
    heading: "3. No Guarantee of Eligibility or Outcome",
    paragraphs: [
      "Submitting an enquiry does not confirm that a vehicle is eligible for retrofit. Final feasibility, configuration, cost, range, timelines and any applicable approvals are subject to technical assessment and depend on the vehicle, the retrofit design and applicable regulations.",
    ],
  },
  {
    heading: "4. Informational Content",
    paragraphs: [
      "Content on this website is provided for general information. It does not constitute a technical specification, a quotation, a warranty or a regulatory approval for any specific vehicle.",
    ],
  },
  {
    heading: "5. Intellectual Property",
    paragraphs: [
      "Brand names and logos referenced on this website belong to their respective owners. Partner references are provided for identification within the technology collaboration.",
    ],
  },
  {
    heading: "6. Limitation of Liability",
    paragraphs: [
      "To the extent permitted by law, we are not liable for decisions made solely on the basis of general information published on this website. Please rely on the outcome of a technical assessment for your specific vehicle.",
    ],
  },
  {
    heading: "7. Governing Law",
    paragraphs: [
      "These terms are governed by applicable laws in India. Any disputes will be subject to the jurisdiction of the appropriate courts.",
    ],
  },
];

export default function Terms() {
  return (
    <>
      <Seo
        title="Terms & Conditions | KAL LORDS ZERO21 DJT"
        description="Terms and conditions for using the KAL LORDS ZERO21 DJT website and submitting EV retrofit enquiries."
        path="/terms"
      />
      <LegalBody
        breadcrumb="Terms & Conditions"
        title="Terms & Conditions"
        description="These terms govern your use of this website and the enquiries you submit through it."
        updated="September 2026"
        sections={sections}
      />
    </>
  );
}